'use client';

import { SectionStack } from '@/components/ui/SectionStack';
import React from 'react';
import Breadcrumb from '@/components/ui/Breadcrumb';
import { Calculators } from '@/features/b2b/resources/components/lifetime-mortgage-calculators/Calculators';
import { Hero } from '@/features/b2b/resources/components/lifetime-mortgage-calculators/Hero';

const breadcrumbItems = [
  {
    label: 'Resources',
    labelMobile: '...',
    href: '/professionals/resources',
  },
  {
    label: 'Lifetime mortgage calculators',
    labelMobile: 'LTM calculators',
    href: '/professionals/resources/lifetime-mortgage-calculators',
  },
];

export const LifetimeMortgageCalculator = () => (
  <SectionStack className="container mx-auto pb-10 md:pb-12 lg:pb-16">
    <div>
      <div className="pt-3">
        <Breadcrumb items={breadcrumbItems}/>
      </div>
      <Hero />
    </div>
    <Calculators />
  </SectionStack>
);
